import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Accordion} from 'react-bootstrap';

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";
import GeneralMedicine from "../../images/services/general-medicine.webp";
import Pediatrics from "../../images/services/pediatrics.webp";
import Physiotherapy from "../../images/services/physiotherapy.webp";
import Diagnostics from "../../images/services/diagnostics-and-lab-tests.webp";
import PreventiveCheckups from "../../images/services/preventive-checkups.webp";
import SpecializedConsultations from "../../images/services/specialized-consultations.webp";
import pdf from "../../images/icon/pdf.png";
import doc from "../../images/icon/doc.png";

const serviceLinks = [
	{
		name: "General Medicine",
		link: "/service/general-medicine",
	},
	{
		name: "Pediatrics",
		link: "/service/pediatrics",
	},
	{
		name: "Physiotherapy",
		link: "/service/physiotherapy",
	},
	{
		name: "Diagnostics & Lab Tests",
		link: "/service/diagnostics-and-lab-tests",
	},
	{
		name: "Preventive Checkups",
		link: "/service/preventive-checkups",
	},
	{
		name: "Specialized Consultations",
		link: "/service/specialized-consultations",
	}
];

class ServiceDetail extends Component{
	
	render(){
		const { serviceType, content } = this.props;
		console.log("Service Type:", serviceType);

		if (!content) {
		return <h2>404: Service not found</h2>;
		}
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>{content.name}</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">{content.name}</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section className="section-area pt-10 pb-10">
						<div className="container">
							<div className="row">
								<div className="col-lg-8 mb-30">
									<div className="ttr-media mb-30">
										{serviceType === 'general-medicine' && <img src={GeneralMedicine} className="rounded" alt=""/>}
										{serviceType === 'pediatrics' && <img src={Pediatrics} className="rounded" alt=""/>}
										{serviceType === 'physiotherapy' && <img src={Physiotherapy} className="rounded" alt=""/>}
										{serviceType === 'diagnostics-and-lab-tests' && <img src={Diagnostics} className="rounded" alt=""/>}
										{serviceType === 'preventive-checkups' && <img src={PreventiveCheckups} className="rounded" alt=""/>}
										{serviceType === 'specialized-consultations' && <img src={SpecializedConsultations} className="rounded" alt=""/>}
									</div>
									<div className="clearfix">
										<div className="head-text mb-30">
											<h2 className="title mb-15" style={{fontSize:"32px"}}>{content.heading}</h2>
											<p className="mb-0">{content.text}</p>
										</div>
										<div className="row align-items-center">
											<h4 className='mt-4'>{content.serviceHeading}</h4>
											<div className="col-md-6 mb-30">
												<ul className="list-check-squer mb-0 mt-3">
													{content.Services.map((service, index) => (
														<li key={index}>{service.title}</li>
													))}
												</ul>
											</div>
											<div className="col-md-6 mb-30">
												{content.reasonChoose.map((reason, index) => (
													<div className="skillbar-box mb-38" key={index}>
														<h6 className="title">{reason.title}</h6>
														{/* <div className="skillbar appear">
															<p className="skillbar-bar" style={{width: "96%"}}></p>
															<span className="skill-bar-percent">96%</span>
														</div> */}
													</div>
												))}
											</div>
										</div>
									</div>
									<div className="clearfix mt-30">
										<Accordion className="accordion ttr-accordion1">
											{content.faq.map((faq, index) => (
												<Accordion.Item eventKey={index.toString()} key={index}>
													<Accordion.Header>{faq.question}</Accordion.Header>
													<Accordion.Body>
														<p className="mb-0">{faq.answer}</p>
													</Accordion.Body>
												</Accordion.Item>
											))}
										</Accordion>
									</div>
								</div>
								<div className="col-lg-4">
									<aside className="sticky-top pb-1">
										<div className="widget">
											<ul className="service-menu">
												{serviceLinks.map((link, index) => (
													<li key={index} className={link.link.includes(serviceType) ? "active" : ""}>
														<Link to={link.link}>
															<span>{link.name}</span>
														</Link>
													</li>
												))}
											</ul>
										</div>
										{/* <div className="widget">
											<div className="brochure-bx">
												<h5 className="title-head">Download</h5>
												<Link to="#" className="download-link">
													<img src={pdf} alt=""/>
													<h5 className="title">Download our Brochures</h5>
													<span>Download</span>
												</Link>
												<Link to="#" className="download-link">
													<img src={doc} alt=""/>
													<h5 className="title">Our Company Details</h5>
													<span>Download</span>
												</Link>
											</div>
										</div> */}
										
									</aside>
								</div>
							</div>
						</div>
					</section>
					
				</div>
				
			</>
		);
	}
}

export default ServiceDetail;